export const SECTION_IDS = {
  SUMMARY: 's1',
  CHALLAN: 's2',
  DRIVER: 's3',
  STOCK_TRANSFER: 's4',
  INVENTORY: 's5',
  SETTLEMENT: 's6',
};

export const STATUS_BADGE_MAP = {
  dispatched: 'b-blue',
  pending: 'b-amber',
  delivered: 'b-green',
  onRoute: 'b-blue',
  available: 'b-green',
  requested: 'b-amber',
  approved: 'b-blue',
  inTransit: 'b-violet',
  in: 'b-green',
  out: 'b-violet',
  normal: 'b-blue',
  high: 'b-amber',
  critical: 'b-red',
};
